var _style, _g, _g2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDineezyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 200",
    style: {
      enableBackground: "new 0 0 500 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E80000;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#969696;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#0F0F0F;stroke-miterlimit:10;}\n\t.st4{fill:#0F0F0F;}\n\t.st5{fill:#DD0000;}\n\t.st6{fill:#FCFCFC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 500,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77,68.4c0-10.4,0-20.7,0-31.3c5.4,0,10.5,0,15.7,0c0,30.9,0,61.8,0,92.9c-5.1,0-10.2,0-15.6,0 c0-1.9,0-3.9,0-6c-0.7,0.3-1.1,0.3-1.5,0.5c-7.1,4.3-14.9,6.4-23.1,6.6c-11.1,0.2-21.5-2.6-29.6-11.1c-5-5.2-7.7-11.7-8.4-19 c-0.7-7,0.3-13.6,3.5-19.8c4.5-8.4,11.5-13.8,20.3-16.4c12.9-3.9,25.4-2.6,37.5,3.3c0.2,0.1,0.3,0.2,0.5,0.2 C76.4,68.4,76.6,68.4,77,68.4z M77.1,96.1c0-3.3,0.1-6.7-0.1-10.1c0-0.9-0.6-2-1.3-2.5c-9.8-6.7-20.4-8.6-31.7-4.8 c-7.7,2.6-12.8,9.5-13,17.2c-0.2,8.4,4.1,15.6,11.9,18.6c11.8,4.6,22.5,2,32.4-5.3c1.5-1.1,2-2.5,1.9-4.3 C77,102.1,77.1,99.1,77.1,96.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.1,
    y: 67.9,
    className: "st0",
    width: 16.7,
    height: 63.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "qr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.9,
    y: 36.9,
    className: "st1",
    width: 25,
    height: 25.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "122.9,62.5 122.9,36.9 104.6,36.9 97.9,36.9 97.9,62.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "97.9,44.9 105.7,44.9 105.7,37.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 39,
    className: "st4",
    width: 4.2,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.7,
    y: 39,
    className: "st4",
    width: 4.2,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 56.1,
    className: "st4",
    width: 4.2,
    height: 4.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "114.8,37.2 114.9,45.2 122.9,45.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "105.7,62.5 105.7,54.5 97.9,54.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "107.8,39.5 109.9,39.5 109.9,41.7 108.9,41.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "113,40.6 113,42.7 113,43.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 112,
    y1: 42.7,
    x2: 113,
    y2: 42.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 112,
    y1: 39.5,
    x2: 113,
    y2: 39.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "109.9,42.7 109.9,46 113,46 113,44.9 113,48.1 114.1,48.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "116.1,47 116.1,49.2 114.1,49.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "117.2,47 120.3,47 120.3,50.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "119.3,53.4 120.3,53.4 120.3,51.3 117.2,51.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "117.2,53.4 117.2,55.6 120.3,55.6 120.3,58.8 118.2,58.8 118.2,56.6 117.2,56.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "113,58.8 115.1,58.8 115.1,59.9 117.2,59.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 119.3,
    y1: 59.9,
    x2: 120.3,
    y2: 59.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "107.8,57.7 107.8,59.9 112,59.9 112,55.6 108.9,55.6 108.9,50.2 112,50.2 112,52.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "110.9,53.4 113,53.4 114.1,53.4 114.1,56.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 116.1,
    y1: 52.4,
    x2: 117.2,
    y2: 52.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "100.5,47 104.7,47 104.7,52.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "100.5,49.2 102.6,49.2 102.6,50.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 100.5,
    y1: 51.3,
    x2: 101.6,
    y2: 51.3
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "106.8,47 109.9,47 109.9,48.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "105.7,50.2 107.8,50.2 107.8,52.4 106.8,52.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "108.9,56.6 110.9,56.6 110.9,57.7  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.7,75.4v13.7c0,0,14.5-6.7,28.4-5.8c16.1,1.1,13.2,14.7,12.2,23.6c0,0-3,24.1-3,24.2h15.2l4.3-31.8 c0,0,3.6-33.3-27.2-31.2c0,0-7.6,0.6-17.9,3.1C129.7,73.2,125.7,75.4,125.7,75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.3,104.2c0.7,3,2.5,5.2,4.4,7c3.2,2.8,7,4.3,11,5.1c9,1.9,19.8,0.5,28.3-2.5l5.2,10.7 c-2.1,1.1-6.3,4.3-19.7,5.6c-5.1,0.4-10.1,0.4-15.1-0.3c-7.9-1.2-15.4-3.9-21.5-9.6c-4.8-4.5-7.5-10.2-8.4-16.8 c-1.1-8.1,0.6-15.4,5.1-21.9c4.2-6,9.8-9.7,16.5-11.9c8-2.7,16.3-2.9,24.4-0.6c12.4,3.4,20.8,11.4,23.9,24.9 c0.6,3.1,0.1,10.8,0.1,10.8L206.3,104.2z M206,92.7c13.3,0,26.5,0,39.8,0c-0.9-3-2.5-5.3-4.7-7.3c-3.3-2.9-7.2-4.3-11.5-4.7 c-5.9-0.6-11.7,0.1-16.9,3.4C209.8,86.2,207.4,88.7,206,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.3,104.2c0.7,3,2.5,5.2,4.4,7c3.2,2.8,7,4.3,11,5.1c9,1.9,19.8,0.5,28.3-2.5l5.2,10.7 c-2.1,1.1-6.3,4.3-19.7,5.6c-5.1,0.4-10.1,0.4-15.1-0.3c-7.9-1.2-15.4-3.9-21.5-9.6c-4.8-4.5-7.5-10.2-8.4-16.8 c-1.1-8.1,0.6-15.4,5.1-21.9c4.2-6,9.8-9.7,16.5-11.9c8-2.7,16.3-2.9,24.4-0.6c12.4,3.4,20.8,11.4,23.9,24.9 c0.6,3.1,0.1,10.8,0.1,10.8L283.3,104.2z M283.1,92.7c13.3,0,26.5,0,39.8,0c-0.9-3-2.5-5.3-4.7-7.3c-3.3-2.9-7.2-4.3-11.5-4.7 c-5.9-0.6-11.7,0.1-16.9,3.4C286.9,86.2,284.5,88.7,283.1,92.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342,130.9c12.7-16.8,25.1-33.3,37.5-49.7c-0.1-0.1-0.1-0.3-0.2-0.4c-10.3,0-20.6,0-31.1,0c0-4.4,0-8.6,0-12.8 c19.8,0,39.6,0,59.9,0c-12.6,16.7-25.1,33.2-37.6,49.6c0.1,0.1,0.2,0.3,0.3,0.4c11.8,0,23.6,0,35.5,0c0,4.5,0,8.8,0,13 C384.9,130.9,363.6,130.9,342,130.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M426.5,108.5h45.9c0,0-3.3,16.9-23.2,16.9C428.9,125.7,426.5,108.5,426.5,108.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M462,64.7c-1.3,4.6,1.2,10.6,6,12.4l-0.5-4.2c-1.8-1.8-2.7-4.7-2.1-7.3c1-4,5-6.2,8.8-5.2c3.9,1.1,6,5.1,5.1,9 c-0.3,1.1-0.7,1.9-1.4,2.8l0.6,4c1.7-1.2,3.8-3.8,4.3-5.8c1.6-5.9-1.9-12-7.6-13.5C469.5,55.4,463.5,58.8,462,64.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.9,68.9l-3.7,25.5c0.4,0.1-2,11.6,2.1,20.5c4.4,9.4,13,14.6,23.5,16.1l0,18.8c0,0,0.2,13.6-14.2,14.4 c0,0-0.8-0.2-0.8,0.9s0,3.2,0,3.2s-0.3,0.9,0.8,0.9s34.7,0,34.7,0s0.8,0.2,0.8-0.9s0-3.2,0-3.2s0.5-0.9-0.8-0.9s-13.4-1-14.2-14.2 s0-19,0-19s29.6-3.2,26.6-33.6l-4.1-28.5c0,0-0.2-2.3-2.2-2.3c-2.1-0.1-3,1-2.8,2.6s3.8,30.2,3.8,30.2s2,25.3-24.3,25.9 c-25.2,0.6-23.6-25.8-23.6-25.8l3.2-30.3c0,0,0.3-2.6-2.2-2.6S423.9,68.9,423.9,68.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDineezyLogo);
export default __webpack_public_path__ + "static/media/dineezyLogo.3cbd9c749067cf8b5a3eebd8f41fc026.svg";
export { ForwardRef as ReactComponent };